/**
 * Purpose:
 *   Prefetch App Router segments and warm heavy chunks on menu hover/focus.
 *   Menu Links use prefetch={false}; intent prefetch replaces viewport auto-prefetch.
 */

'use client';

import { useCallback } from 'react';
import { useRouter } from 'next/navigation';
import { prefetchRouteOnIntent } from '@/lib/navigation/prefetchRouteOnIntent';
import { warmSubscriptionsListChunk } from '@/lib/navigation/warmSubscriptionsListChunk';

export function useMenuRoutePrefetch() {
  const router = useRouter();

  return useCallback((href: string) => {
    prefetchRouteOnIntent(
      href,
      (path) => {
        router.prefetch(path);
      },
      warmSubscriptionsListChunk
    );
  }, [router]);
}